import { ChangeEvent, MouseEvent, useEffect, useState } from 'react';
import { UploadIcon } from '~/components/Icon/UploadIcon';
import styles from './File.module.css';
import { SyncIcon } from '~/components/Icon/SyncIcon';

interface Props {
  onChange: (files: File[]) => void;
  isUploading?: boolean;
  disabled?: boolean;
  multiple?: boolean;
  accept?: string;
}

export function File({ accept, onChange, isUploading = false, disabled = false, multiple = false }: Props) {
  const [files, setFiles] = useState<File[]>([]);

  function handleUploadButtonClick(event: MouseEvent<HTMLButtonElement>) {
    (event.target as HTMLButtonElement).closest('label')?.click();
  }

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    if (!event.target.files) {
      return;
    }

    setFiles(Array.from(event.target.files));
  }

  const prevent = disabled || isUploading;

  useEffect(() => {
    if (files.length > 0) {
      onChange(files);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);

  return (
    <div className={styles.file}>
      <label htmlFor="file">
        {isUploading ? <SyncIcon className={styles.spin} /> : <UploadIcon />}

        <button type="button" onClick={handleUploadButtonClick}>
          {isUploading ? `Laddar upp valda filer...` : 'Välj filer att ladda upp'}
        </button>

        <input type="file" id="file" onChange={handleChange} disabled={prevent} multiple={multiple} accept={accept} />
      </label>
    </div>
  );
}
